import { Box } from '@palmetto/palmetto-components';
import { ReactNode } from 'react';

type PageHeaderTitleProps = {
  className?: string;
  [key: `data-${string}`]: string | undefined;
};

interface PageHeaderProps {
  title: string;
  description?: string | ReactNode;
  children?: ReactNode;
  className?: string;
  eyebrow?: ReactNode;
  titleProps?: PageHeaderTitleProps;
}

const PageHeader = ({ title, description, children, className, eyebrow, titleProps, ...rest }: PageHeaderProps) => {
  const { className: titleClassName, ...titleRest } = titleProps ?? {};

  return (
    <Box
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      className={className}
      color="contrast"
      padding={{ base: '0 lg', tablet: '0' }}
      flex="auto"
      {...rest}
    >
      <Box display="block" childGap="2xs">
        {eyebrow && <Box display="block">{eyebrow}</Box>}

        {title && (
          <Box
            as="h1"
            fontSize={{ base: 'lg', tablet: 'xl', desktop: '2xl' }}
            fontWeight="medium"
            className={['page-header-title', titleClassName].filter(Boolean).join(' ')}
            {...titleRest}
          >
            {title}
          </Box>
        )}
        {description && (
          <Box
            fontSize={{
              base: 'sm',
              tablet: 'md',
              desktop: 'lg',
            }}
            color="body-secondary"
          >
            {description}
          </Box>
        )}
      </Box>
      {children && <Box display="block">{children}</Box>}
    </Box>
  );
};

export default PageHeader;
